import { Bot } from 'lucide-react';

interface LoadingIndicatorProps {
  botLogo?: string;
  primaryColor: string;
  fallbackImage: string;
}

export default function LoadingIndicator({
  botLogo,
  primaryColor,
  fallbackImage,
}: LoadingIndicatorProps) {
  return (
    <div className="flex gap-3 items-start">
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
        style={{ backgroundColor: primaryColor }}
      >
        {botLogo ? (
          <img
            src={botLogo}
            onError={(e) => (e.currentTarget.src = fallbackImage)}
            alt="Bot"
            className="w-full h-full object-cover rounded-full"
          />
        ) : (
          <Bot size={16} className="text-white" />
        )}
      </div>
      <div className="bg-white dark:bg-gray-700/60 rounded-sm rounded-tl-none px-4 py-3 shadow-sm border border-gray-100 dark:border-gray-700">
        <div className="flex gap-1">
          <div
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          ></div>
          <div
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          ></div>
          <div
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          ></div>
        </div>
      </div>
    </div>
  );
}
